<template>
    <div class="flex flex-col-reverse mt-4 lg:justify-between lg:flex-row lg:mt-0">
        <nav class="lg:w-8/12 mt-2 mb-1 justify-center">
            <ul class="flex text-white text-sm lg:text-lg">
                <li class="flex-auto px-2 text-center" v-for="(item, index) in menuItems" :key=index>
                    <span>
                        <router-link
                            v-if="item.post"
                            :to="routeFor('detail', {slug: item.post.title, pk: item.post.id})"
                        >
                            {{ item.name }}
                        </router-link>
                        <a v-else :href="item.url">{{item.name}}</a>
                    </span>
                </li>
            </ul>
        </nav>
        <div class="flex justify-center">
            <div class="flex px-2 text-center bg-gray-100 bg-opacity-40 rounded-lg text-shadow">
                <span class="flex items-center text-white text-sm lg:text-lg">
                    <small class="mr-1 mt-1"> Logado como: </small>
                    <span>{{personName}}</span>
                    <a href="#" class="hover:underline" title="Fazer logout" @click="handleLogout">(Sair)</a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, inject } from 'vue'
import api from '@/services'
import { routeFor } from '@/helpers'

export default {
    setup() {
        async function handleLogout()
        {
            const response = await api.auth.logout()
            window.location = response.request.responseURL
        }

        const userData = JSON.parse(sessionStorage.getItem('user-data'))
        const compoundName = `${userData.first_name} ${userData.last_name}`

        const state = reactive({
            menuItems: [],
            routeFor: routeFor,
            personName: (compoundName.trim()) ? compoundName : userData.username,
            handleLogout
        })

        const globalState = inject('globalState')

        globalState.loadingTasks++
        api.menu.topMenu().then(result => {
            state.menuItems = result
            globalState.loadingTasks--
        })

        return state
    }
}
</script>
<style>
</style>